export enum NicheFilesActionTypes {
  FETCH_COUNTY_PRICE = "@@NICHE_FILES/FETCH_COUNTY_PRICES",
  FETCH_COUNTY_PRICE_SUCCESS = "@@NICHE_FILES/FETCH_COUNTY_PRICES_SUCCESS",
  FETCH_COUNTY_PRICE_FAILURE = "@@NICHE_FILES/FETCH_COUNTY_PRICES_FAILURE",

  GET_SUBSCRIPTION = "@@NICHE_FILES/GET_SUBSCRIPTION",
  GET_SUBSCRIPTION_SUCCESS = "@@NICHE_FILES/GET_SUBSCRIPTION_SUCCESS",
  GET_SUBSCRIPTION_FAILURE = "@@NICHE_FILES/GET_SUBSCRIPTION_FAILURE",

  GET_SUBSCRIPTIONS = "@@NICHE_FILES/GET_SUBSCRIPTIONS",
  GET_SUBSCRIPTIONS_SUCCESS = "@@NICHE_FILES/GET_SUBSCRIPTIONS_SUCCESS",
  GET_SUBSCRIPTIONS_FAILURE = "@@NICHE_FILES/GET_SUBSCRIPTIONS_FAILURE",

  CREATE_SUBSCRIPTION = "@@NICHE_FILES/CREATE_SUBSCRIPTION",
  CREATE_SUBSCRIPTION_SUCCESS = "@@NICHE_FILES/CREATE_SUBSCRIPTION_SUCCESS",
  CREATE_SUBSCRIPTION_FAILURE = "@@NICHE_FILES/CREATE_SUBSCRIPTION_FAILURE",

  CANCEL_SUBSCRIPTION = "@@NICHE_FILES/CANCEL_SUBSCRIPTION",
  CANCEL_SUBSCRIPTION_SUCCESS = "@@NICHE_FILES/CANCEL_SUBSCRIPTION_SUCCESS",
  CANCEL_SUBSCRIPTION_FAILURE = "@@NICHE_FILES/CANCEL_SUBSCRIPTION_FAILURE",

  RENEW_SUBSCRIPTION = "@@NICHE_FILES/RENEW_SUBSCRIPTION",
  RENEW_SUBSCRIPTION_SUCCESS = "@@NICHE_FILES/RENEW_SUBSCRIPTION_SUCCESS",
  RENEW_SUBSCRIPTION_FAILURE = "@@NICHE_FILES/RENEW_SUBSCRIPTION_FAILURE",

  CREATE_CHECKOUT_LINK = "@@NICHE_FILES/CREATE_CHECKOUT_LINK",

  ADD_STATE = "@@NICHE_FILES/ADD_STATE",
  REMOVE_STATE = "@@NICHE_FILES/REMOVE_STATE",
  ADD_COUNTY = "@@NICHE_FILES/ADD_COUNTY",
  REMOVE_COUNTY = "@@NICHE_FILES/REMOVE_COUNTY",

  GET_NICHE_FILE = "@@NICHE_FILES/GET_NICHE_FILE",
  GET_NICHE_FILE_SUCCESS = "@@NICHE_FILES/GET_NICHE_FILE_SUCCESS",
  GET_NICHE_FILE_FAILURE = "@@NICHE_FILES/GET_NICHE_FILE_FAILURE",

  DELETE_NICHE_FILE = "@@NICHE_FILES/DELETE_NICHE_FILE",
  DELETE_NICHE_FILE_SUCCESS = "@@NICHE_FILES/DELETE_NICHE_FILE_SUCCESS",
  DELETE_NICHE_FILE_FAILURE = "@@NICHE_FILES/DELETE_NICHE_FILE_FAILURE",

  UPDATE_NICHE_FILE_STATUS = "@@NICHE_FILES/UPDATE_NICHE_FILE_STATUS",
  UPDATE_NICHE_FILE_STATUS_SUCCESS = "@@NICHE_FILES/UPDATE_NICHE_FILE_STATUS_SUCCESS",
  UPDATE_NICHE_FILE_STATUS_FAILURE = "@@NICHE_FILES/UPDATE_NICHE_FILE_STATUS_FAILURE",

  GET_NICHE_FILES = "@@NICHE_FILES/GET_NICHE_FILES",
  GET_NICHE_FILES_SUCCESS = "@@NICHE_FILES/GET_NICHE_FILES_SUCCESS",
  GET_NICHE_FILES_FAILURE = "@@NICHE_FILES/GET_NICHE_FILES_FAILURE",

  CLEAR_NICHE_FILES = "@@NICHE_FILES/CLEAR_NICHE_FILES",
  CLEAR_NICHE_FILE = "@@NICHE_FILES/CLEAR_NICHE_FILE",
  SET_FILTER = "@@NICHE_FILES/SET_FILTER",

  CLEAR_ERRORS = "@@NICHE_FILE/CLEAR_ERRORS",

  DOWNLOAD_NICHE_FILE = "@@NICHE_FILE/DOWNLOAD_NICHE_FILE",
}
